export type ProfileExportDownloader = (serializedProfile: string) => void;

export function downloadProfileExport(serializedProfile: string): void {
  const blob = new Blob([serializedProfile], {
    type: "application/json;charset=utf-8"
  });
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");

  try {
    link.download = "little-launch-island-profile.json";
    link.href = objectUrl;
    link.hidden = true;
    document.body.append(link);
    link.click();
  } finally {
    link.remove();
    URL.revokeObjectURL(objectUrl);
  }
}
